export default {
  namespaced: true,
  state: {
    videoUploadModal: {
      Show: false,
      type: "",
      id: "",
      videoObj: {},
    },
    videoDetailsUploadModal: {
      Show: false,
      type: "",
      id: null,
    },
    addPlaylistModal: {
      Show: false,
    },
    showSnackbar: {
      Show: false,
    },
  },
  getters: {
    getVideoUploadModalShow: (state) => state.videoUploadModal.Show,
    getVideoUploadModalId: (state) => state.videoUploadModal.id,
    getVideoDetails: (state) => state.videoDetailsUploadModal.Show,
    getPlaylistModalShow: (state) => state.addPlaylistModal.Show,
    getSnackbarShow: (state) => state.showSnackbar.Show,
  },
  mutations: {
    TOGGLE_VIDEO_UPLOAD_MODAL(state, payloadObj) {
      console.log("type", payloadObj);
      if (payloadObj.Show) {
        state.videoUploadModal.type = payloadObj.type ? payloadObj.type : "";
        state.videoUploadModal.id = payloadObj.id ? payloadObj.id : null;
        state.videoUploadModal.videoObj = payloadObj.videoObj
          ? payloadObj.videoObj
          : {};
      }
      state.videoUploadModal.Show = payloadObj.Show;
    },
    TOGGLE_VIDEO_DETAILS_UPLOAD_MODAL(state, payloadObj) {
      if (payloadObj.Show) {
        state.videoDetailsUploadModal.type = payloadObj.type
          ? payloadObj.id
          : null;
        state.videoDetailsUploadModal.id = payloadObj.id ? payloadObj.id : null;
      }
      state.videoDetailsUploadModal.Show = payloadObj.Show;
    },
    TOGGLE_PLAYLIST_MODAL(state, payloadObj) {
      state.addPlaylistModal.Show = payloadObj.Show;
    },
    TOGGLE_SNACKBAR(state, payloadObj) {
      state.showSnackbar.Show = payloadObj.Show;
    },
  },
  actions: {
    toggleVideoUploadModal({ commit }, payloadObj) {
      commit("TOGGLE_VIDEO_UPLOAD_MODAL", payloadObj);
    },
    toggleVideoDetailsUploadModal({ commit }, payloadObj) {
      commit("TOGGLE_VIDEO_DETAILS_UPLOAD_MODAL", payloadObj);
    },
    toggleVideoSaveOrEditAction({ commit }, payloadObj) {
      commit("TOGGLE_VIDEO_SAVE_OR_EDIT", payloadObj);
    },
    togglePlaylistModal({ commit }, payloadObj) {
      commit("TOGGLE_PLAYLIST_MODAL", payloadObj);
    },
    toggleSnackbar({ commit }, payloadObj) {
      commit("TOGGLE_SNACKBAR", payloadObj);
    },
  },
};
